<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="copyrightPage">
<p class="copyrightText">© 2005 by Alexander Mikaberidze</p>
<p class="copyrightText1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher. Printed in the United States of America.</p>
<p class="copyrightText1">Cataloging-in-Publication Data is available from the Library of Congress.</p>
<p class="copyrightText1">First Savas Beatie edition 2005</p>
<p class="copyrightText1">ISBN 10: 1-932714-02-2</p>
<p class="copyrightText2">ISBN 13: 978-1-932714-02-9</p>
<p class="copyrightText2">eISBN: 978-1-61121-002-6</p>
<p class="leftImage1"><img alt="images" id="imgsb" src="images/imgsb.jpg"/></p>
<p class="copyrightText2">Published by</p>
<p class="copyrightText2">Savas Beatie LLC</p>
<p class="copyrightText2">521 Fifth Avenue, Suite 1700</p>
<p class="copyrightText2">New York, NY 10175</p>
<p class="copyrightText1">Editorial Offices:</p>
<p class="copyrightText1">Savas Beatie LLC</p>
<p class="copyrightText2">P.O. Box 4527</p>
<p class="copyrightText2">El Dorado Hills, CA 95762</p>
<p class="copyrightText2">Phone: 916-941-6896</p>
<p class="copyrightText2">(E-mail) sales@savasbeatie.com</p>
<p class="copyrightTextS">Savas Beatie titles are available at special discounts for bulk purchases in the United States by corporations, institutions, and other organizations. For more details, please contact Special Sales, P.O. Box 4527, El Dorado Hills, CA 95762, or e-mail your inquires or orders to us at sales@savasbeatie.com, or visit our website at <a href="http://www.savasbeatie.com" target="_blank">www.savasbeatie.com</a> for additional information.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_copyright.vue?0c7c109c